import htmlImg from "./html5.png";
import cssImg from "./css3.png";
import jsImg from "./javascript.png";
import bootImg from "./bootstrape.png";
import sassImg from "./sass.png";
import gitImg from "./git.png";
//import githubImg from './github.png'
//import webpackImg from './webpack.png'
import figmaImg from "./figmaC.png";
import reactImg from "./react.png";
import npmImg from "./npm.png";
import reduxImg from "./reduxx.png";
import nextImg from "./next.png";
import tsImg from "./ts.png";
import nodeImg from "./node-js.png";
import mongoImg from "./mongo.png";
import jestImg from "./jest.png";
import wavingHandImg from "./waving-hand.png";
import overlayImg from "./overlay-img.png";

export const wavingHand = wavingHandImg
export const overlayImage = overlayImg

export const COLORED_IMAGES = {
  htmlImg,
  cssImg,
  jsImg,
  bootImg,
  sassImg,
  gitImg,
  figmaImg,
  reactImg,
  npmImg,
  reduxImg,
  nextImg,
  tsImg,
  nodeImg,
  mongoImg,
  jestImg,
};